import * as React from 'react';

export const CelebrateIcon = ({ className }: { className?: string }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.226562 21.2705L14.2266 16.2705L5.22656 7.27047L0.226562 21.2705ZM10.5766 15.4505L3.52656 17.9705L6.04656 10.9205L10.5766 15.4505Z"
      fill="white"
    />
    <path
      d="M12.7566 11.8005L18.3466 6.21047C18.8366 5.72047 19.6266 5.72047 20.1166 6.21047L20.7066 6.80047L21.7666 5.74047L21.1766 5.15047C20.1066 4.08047 18.3566 4.08047 17.2866 5.15047L11.6966 10.7405L12.7566 11.8005Z"
      fill="white"
    />
    <path
      d="M8.28656 6.15047L7.69656 6.74047L8.75656 7.80047L9.34656 7.21047C10.4166 6.14047 10.4166 4.39047 9.34656 3.32047L8.75656 2.73047L7.69656 3.80047L8.28656 4.39047C8.76656 4.87047 8.76656 5.67047 8.28656 6.15047Z"
      fill="white"
    />
    <path
      d="M15.2866 11.1505L13.6966 12.7405L14.7566 13.8005L16.3466 12.2105C16.8366 11.7205 17.6266 11.7205 18.1166 12.2105L19.7266 13.8205L20.7866 12.7605L19.1766 11.1505C18.0966 10.0805 16.3566 10.0805 15.2866 11.1505Z"
      fill="white"
    />
    <path
      d="M13.2866 5.15047L9.69656 8.74047L10.7566 9.80047L14.3466 6.21047C15.4166 5.14047 15.4166 3.39047 14.3466 2.32047L12.7566 0.730469L11.6966 1.79047L13.2866 3.38047C13.7666 3.87047 13.7666 4.67047 13.2866 5.15047Z"
      fill="white"
    />
  </svg>
);
